import styled from "styled-components";

export const PerfilStyled = styled.div`
	.perfil-card {
		color: var(--color-white-fixed);
		padding: 20px 40px;
		width: 600px;
		background-color: var(--color-brand-2);
		border-radius: 5px;
		margin: 0 auto;

		.perfil-info {
			display: flex;
			justify-content: space-between;
			color: var(--color-white-fixed);

			.info-follow {
				display: flex;
				align-items: center;
				justify-content: end;

				#follower,
				#following {
					width: 10rem;
					display: flex;
					flex-direction: column;
					text-align: center;

					cursor: pointer;
				}
			}

			.info-user {
				img#user-img {
					width: 60px;
					height: 60px;
					border-radius: 50%;
					background-color: var(--color-white-fixed);
					box-shadow: 0px 2px 3px var(--color-gray-0);
				}

				img#user-icon {
					width: 15px;
					height: 15px;
				}

				.text {
					display: flex;
					flex-direction: column;

					span {
						color: var(--color-gray-3);
						display: flex;
						align-items: center;
						column-gap: 0.2rem;
					}

					small {
						font-weight: var(--fw-regular);
						align-self: flex-end;
					}

					p {
						width: 27ch;
					}
				}

				.bio-user {
					padding: 6px 0;
					display: flex;
					justify-content: space-between;
				}
			}
		}

		.perfil-img {
			margin-top: 2rem;
			display: grid;
			grid-template-columns: repeat(
				auto-fill,
				minmax(120px, 1fr)
			); /* Ajustado para 120px */
			grid-auto-flow: row;
			grid-gap: 10px; /* Espaçamento entre imagens */
			height: 370px;
			overflow-y: scroll;

			img {
				width: 120px;
				height: 120px; /* Define a altura fixa */
				object-fit: cover; /* Mantém a proporção da imagem, cortando se necessário */
				border-radius: 15px;
				box-shadow: 0px 2px 3px var(--color-gray-0);
			}

			#teste {
				background-color: aliceblue;
				height: 4rem;
			}
		}
		/*
		#sentinelaPerfil {
			height: 4rem;
		} */
	}

	.card {
		margin: 1rem auto;
		padding: 10px 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		form {
			margin-top: 1rem;
			display: flex;
			flex-direction: column;
			row-gap: 1rem;
		}
	}

	@media screen and (max-width: 460px) {
		.perfil-card {
			width: 100%;
			min-width: 320px;
			.perfil-info {
				display: flex;
				flex-direction: column;

				position: relative;
				.info-follow {
					position: absolute;
					right: 0;
					top: 20px;
				}
			}

			.perfil-img {
				width: 100%;
			}
		}
	}
`;
